module.exports = __webpack_public_path__ + "static/media/avatar.bfe7361e.svg";